import React, { useEffect, useState } from "react";
import { useParams,Link } from "react-router-dom";
import "../../common/planTheme.css";
import "./ReportView.css";
import DayPlan from "./ViewDayPlan";
import axios from "axios";
import Swal from "sweetalert2";
import {DecryptED} from "../../DecryptJS/Decrypt"
import { FcDownload } from "react-icons/fc";
import { handleDownloadExcel } from "../ExportToExcel";
import { getWeeklyPlanConfig } from "../weeklyPlanConfig";

const WeeklyReportView = () => {
  let { sid, userid, reportid } = useParams();
  sid = DecryptED(sid);
  userid = DecryptED(userid);
  const cfg = getWeeklyPlanConfig(sid);
  const [weeklyData, setWeeklyData] = useState([]);
  const [lessonName, setLessonName] = useState("");
  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [month, setMonth] = useState("");
  const [className, setClassName] = useState("");
  const [subject, setSubject] = useState("");
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const [exportData, setExportData] = useState({
    headers: [
      "Days", "Subject", "sub topic", "Class_Division", "Lesson Name", "Period",
      cfg.teacherActivityLabel ? "Teacher's Activity" : "imp. notes",
      "class activity",
      ...(cfg.learningOutcomes ? ["Learning Outcomes"] : []),
      cfg.assignmentLabel ? "Assignment" : "HomeWork",
      ...(cfg.hideAccomplished ? [] : ["accomplished"]),
      "if No reason"
    ],
    body: []
  }
  )

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!month || !lessonName) {
      const missing = [];
      if (!month) missing.push("Month");
      if (!lessonName) missing.push("Lesson Name");
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Please fill the required fields: ${missing.join(", ")}`,
      });
      return;
    }
    const data = {
      fun_name: "updateWeeklyLessonplanData",
      staff_id: userid,
      sid,
      class_id: classId,
      subject_id: subjectId,
      month,
      lession_name: lessonName,
      lesson_id: reportid,
      days: weeklyData,
    };
    setUpdating(true);
    try {
      const response = await axios.post(
        "https://topschool.prisms.in/rest/index.php/staff_list.json",
        data
      );
      if (response.data && response.data.success !== false) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Plan has been updated successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire("Error", (response.data && response.data.message) || "Could not update the plan", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Could not update the plan. Please try again.", "error");
    } finally {
      setUpdating(false);
    }
  };
  useEffect(() => {
    const getReportData = async () => {
      const data = {
        fun_name: "getWeeklyLessonPlanByID",
        staff_id: userid,
        sid,
        id: reportid,
      };
      try {
        const response = await axios.post(
          "https://topschool.prisms.in/rest/index.php/staff_list.json",
          data
        );
        const obj = (response.data && response.data.result) || [];
        if (!obj.length) {
          Swal.fire("Error", "Weekly plan not found", "error");
          return;
        }
        setLessonName(obj[0].lession_name);
        setMonth(obj[0].month);
        setClassName(obj[0].div_name);
        setSubject(obj[0].subject);
        setWeeklyData(obj);
        setClassId(obj[0].class_id);
        setSubjectId(obj[0].subject_id);
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Could not load the weekly plan. Please try again.", "error");
      } finally {
        setLoading(false);
      }
    };
    getReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {  
    const myArray = weeklyData.map(item => {
      return {
        Days: item.days,
        subject: item.subject,
        top_sub_top: item.top_sub_top,
        div_name: item.div_name,
        Lesson_Name: item.lession_name,
        Period: item.no_of_period,
        imp_notes: item.imp_note,
        class_activity: item.cls_activity,
        ...(cfg.learningOutcomes ? { learning_outcome: item.learning_outcome } : {}),
        HomeWork: item.homework,
        ...(cfg.hideAccomplished ? {} : { accomplished: item.accomplished }),
        if_No_reason: item.if_no_reas_with_comp_date
      }
    });
    setExportData((prev) => ({...prev, body: myArray}))
  }, [weeklyData])

  if (loading) {
    return (
      <div className="lp-scope weeklyreportview-page">
        <p className="lp-page-title" style={{ textAlign: "center" }}>Weekly Lesson Plan</p>
        <p style={{ textAlign: "center", padding: "20px", color: "#1565c0" }}>
          Loading…
        </p>
      </div>
    );
  }

  return (
    <div className="lp-scope weeklyreportview-page">
      <div className="weeklyform-headRow">
        <Link className="weeklyform-navLink" to={`/weeklyHome/${sid}/${userid}`}>
          Home
        </Link>
        <p className="lp-page-title" style={{ margin: 0 }}>Weekly Lesson Plan</p>
        <Link className="weeklyform-navLink" to={`/weeklyReport/${sid}/${userid}`}>
          Report
        </Link>
      </div>
      <form className="form lp-card" onSubmit={handleUpdate}>
        <div className="user-details">
          <div className="weeklyreportview-titleRow">
            <p className="lp-section-title" style={{ margin: 0 }}>Lesson Details</p>
            <button
              type="button"
              className="weeklyreportview-downloadBtn"
              aria-label="Download as Excel"
              onClick={()=>handleDownloadExcel(exportData.headers, exportData.body)}
            >
              <FcDownload size={22} />
            </button>
          </div>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="classDisplay">Class</label>
              <input className="lp-input" id="classDisplay" value={className} readOnly aria-readonly="true" />
            </div>
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="month">
                Month<span className="lp-required">*</span>
              </label>
              <input
                className="lp-input"
                onChange={(e) => setMonth(e.target.value)}
                name="month"
                id="month"
                type="date"
                value={month}
              />
            </div>
          </div>
          <div className="form-details">
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="subjectDisplay">Subject</label>
              <input className="lp-input" id="subjectDisplay" value={subject} readOnly aria-readonly="true" />
            </div>
            <div className="form-inputs">
              <label className="lp-field-label" htmlFor="lessonName">
                Lesson Name<span className="lp-required">*</span>
              </label>
              <input
                className="lp-input"
                value={lessonName}
                onChange={(e) => setLessonName(e.target.value)}
                id="lessonName"
                type="text"
              />
            </div>
          </div>
        </div>
        <p className="lp-section-title" style={{ marginTop: "24px" }}>Day-by-Day Plan</p>
        <div className="Accordion">
          {days.map((day, idx) => {
            return (
              <DayPlan
                day={day}
                key={idx}
                weeklyData={weeklyData}
                setWeeklyData={setWeeklyData}
              />
            );
          })}
        </div>
        <div className="btn-div">
          <button
            type="submit"
            className="lp-btn lp-btn-primary"
            disabled={updating}
          >
            {updating ? "Updating…" : "Update"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default WeeklyReportView;
